<template>
  <div ref="information" class="information" v-if="menuGroup">
    <div class="content banxin">
      <div class="subpage-tit">
        {{title}}
      </div>
      <TopImg :url="url"/>
      <div class="title">
        <div class="menu" ref="myControlMenuContainer">
          <ul ref="myControlMenu">
            <li v-for="(item, index) in menuGroup" :key="index" :class="{act: item.act}" @click="handleSwitchMenu(index)">
              {{item.name}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cont">
      <div class="menu-info" v-if="actObj.content">
        <div class="banxin" v-html="actObj.content"></div>
      </div>
      <div class="submenu-container menu-info" v-else>
        <div class="banxin">
          <ul>
            <li v-for="(item, index) in subMenuGroup" :key="item.id" :class="{act: item.act}" @click="handleSwitchSubMenu(index)">
              {{item.name}}
            </li>
          </ul>
          <div class="submenu-info" v-html="subMenuGroup.find(item => item.act).content">
            
          </div>
        </div>
      </div>
      <ul v-if="group.length > 0">
        <li v-for="(item, i) in group" :key="i" @click="handleClick(item)">
          <div class="banxin">
            <div class="subtit">
              <div class="create_time left">
                {{item.create_time | formateTime}}
              </div>
              <div class="left">
                <img v-if="item.is_new === 1" src="../assets/imgs/new.png" alt="">{{item.title}}
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="next-page" v-if="isScroll" @click="handleRender">下一页</div>
    </div>
  </div>
</template>
<script>
import TopImg from '@/components/TopImg'
export default {
  components: {
    TopImg,
  },
  props: {
    title: {
      type: String,
      required: true
    },
    api: {
      type: String,
      required: true
    },
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menuGroup: null,
      subMenuGroup: null,
      actObj: null,
      group: [],
      isScroll: false,
      distance: 0,
      totalScroll: 0,
      params: {
        page: 1,
         psize: 10
      }
    }
  },
  computed: {
    menuEle() {
      return this.$refs.myControlMenu
    },
    menuEleBox() {
      return this.$refs.myControlMenuContainer
    },
  },
  methods: {
    handleClick(obj) {
      this.$router.push('/Home/Article/' + obj.id)
    },
    handleSwitchMenu(i) {
      this.group = []
      this.menuGroup.map((ele, index) => {
        if(i === index) {
          ele.act = true
        } else {
          ele.act = false
        }
      })
      var _arr = []
      if(this.menuGroup[i]['list']){
        this.menuGroup[i]['list'].forEach((item, i) => i === 0 ? _arr.push({...item,act: true}) : _arr.push({...item,act: false}))
      }
      this.subMenuGroup = _arr
      this.actObj = this.menuGroup[i]
      this.menuGroup = [...this.menuGroup]
      if(_arr.length > 0) this.handleSwitchSubMenu(0)
    },
    handleSwitchSubMenu(i) {
      this.params.page = 1
      this.group = []
      this.subMenuGroup.map((ele, index) => {
        if(i === index) {
          ele.act = true
        } else {
          ele.act = false
        }
      })
      this.subMenuGroup = [...this.subMenuGroup]
      this.handleRender()
    },
    handleRender() {
      if(!this.subMenuGroup) return
      var obj = this.subMenuGroup.find(item => item.act)
      if(!obj) return
      var channelid = this.subMenuGroup.find(item => item.act).id
      this.$store.dispatch('get_article_list', {...this.params, channelid})
      .then(res => {
        if(res.data.length > 0) {
          this.group = [...this.group, ...res.data]
          this.params.page++
          res.data.length < this.params.psize ? this.isScroll = false : this.isScroll = true
        }else {
          this.isScroll = false
        }
      })
    },
    handleResetMenu() {
      var arr = this.menuGroup
      arr.forEach((ele, i) => {
        if(i == 0) {
          ele.act = true
        }else {
          ele.act = false
        }
      });
      this.menuGroup = arr
      this.actObj = this.menuGroup[0]
      var _arr = []
      if(this.menuGroup[0]['list']) {
        this.menuGroup[0]['list'].forEach((item, i) => i === 0 ? _arr.push({...item,act: true}) : _arr.push({...item,act: false}))
      }
      this.subMenuGroup = _arr
      if(arr.length > 0) this.handleRender(0)
    }
  },
  mounted() {
    this.$store.dispatch(this.api)
    .then(res => {
      this.menuGroup = res
      this.handleResetMenu()
    })
  }
}
</script>

<style lang="less" scoped>
.information {
  .title {
    position: relative;
    margin-top: 1.5rem;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    min-height: 2.5rem;
    .menu {
      &::-webkit-scrollbar {
        display: none !important;
        height: 5px;
      }
      ul {
        overflow: hidden;
        li {
          float: left;
          padding: 0.7rem;
          color: rgba(153, 153, 153, 1);
          font-size: 0.9rem;
          cursor: pointer;
          margin-right: 1rem;
          border-bottom: 0.1rem solid rgba(21, 137, 245, 0);
          white-space: nowrap;
        }
        li:last-child {
          margin-right: 0;
        }
        li.act {
          color: @btn-background ;
          border-bottom: 0.1rem solid @btn-background ;
        }
      }
    }
  }
  .cont {
    margin-top: 0.2rem;
    .menu-info {
      background: #F5F5F5;
      padding: 1.5rem 0;
      /deep/ p {
        margin-bottom: 0;
        font-size: 0.9rem;
        line-height: 1.6rem;
      }
    }
    .submenu-container {
      .banxin {
        ul {
          margin-bottom: 1rem;
          display: flex;
          flex-wrap: wrap;
          li {
            font-size: 0.8rem;
            cursor: pointer;
            padding: 0.3rem 0.9rem;
            color: #666666;
            border-radius: 0.85rem;
          }
          li.act {
            background: #1589F5;
            color: #fff;
          }
        }
        .submenu-info {
          padding-top: 1.1rem;
          border-top: 1px solid #eee;
        }
      }
    }
    >ul {
      padding-top: 1.2rem;
      li {
        cursor: pointer;
        padding-left: 0.95rem;
        border-bottom: 1px solid #eee;
        .subtit {
          font-size: 0.9rem;
          line-height: 2.45rem;
          display: flex;
          overflow: hidden;
          .left {
            display: flex;
            align-items: center;
            img {
              width: 2.2rem;
              height: 1rem;
              margin-right: 0.5rem;
            }
          }
          .create_time {
            margin-right: 3.5rem;
          }
        }
      }
      li:hover {
        background: rgba(54, 143, 254, .1);
      }
    }
    .nodata {
      text-align: center;
      font-size: 0.8rem;
      padding: 1rem;
    }
  }
  .next-page {
    width: 240px;
    height: 50px;
    color: #666666;
    background: #eeeeee;
    cursor: pointer;
    text-align: center;
    line-height: 50px;
    font-size: 0.9rem;
    margin: 0 auto;
    margin-top: 20px;
  }
}
</style>
